import { call, put, takeLatest } from "redux-saga/effects";
import { authApi } from "../../../api/auth/authApi";
import { NotifyHelper } from "../../../helpers/toast";
import { ILoginRequest } from "../../../model/request/auth/ILoginRequest";
import { ILoginVnptRequest } from "../../../model/request/auth/ILoginVnptRequest";
import { ILoginNamVietRequest } from "../../../model/request/auth/ILoginNamVietRequest";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { ILoginRespone } from "../../../model/respone/auth/ILoginRespone";
import { eAuthActionTypeIds, IAuthActions } from "../../action-types/auth/IAuthActions";
import { rootActions } from "../../actions/rootActions";

export function* authSaga(): any {
    yield takeLatest(eAuthActionTypeIds.LOGIN_START, loginWorker);
    yield takeLatest(eAuthActionTypeIds.LOGIN_VNPT_START, loginVnptWorker);
    yield takeLatest(eAuthActionTypeIds.LOGIN_NAMVIET_START, loginNamVietWorker);
}

function* loginWorker(action: IAuthActions): any {
    const res: IBaseRespone<ILoginRespone> = yield call(authApi.Login, action.payload as ILoginRequest);
    yield* handleLoginResult(res);
}

function* loginVnptWorker(action: IAuthActions): any {
    const res: IBaseRespone<ILoginRespone> = yield call(authApi.LoginVnpt, action.payload as ILoginVnptRequest);
    yield* handleLoginResult(res);
}

function* loginNamVietWorker(action: IAuthActions): any {
    const res: IBaseRespone<ILoginRespone> = yield call(authApi.LoginNamViet, action.payload as ILoginNamVietRequest);
    yield* handleLoginResult(res);
}

/** Xử lý chung response của 3 luồng đăng nhập (mật khẩu / VNPT / Nam Việt). */
function* handleLoginResult(res: IBaseRespone<ILoginRespone>): any {
    if (res.is_success && res.data) {
        NotifyHelper.Success(`Chào ${res.data.user.ho_ten}!`);
        yield put(rootActions.auth.LOGIN_SUCCESS(res.data));
    } else {
        NotifyHelper.Error(res.message || "Đăng nhập thất bại.");
        yield put(rootActions.auth.LOGIN_ERROR(res.message || "Đăng nhập thất bại."));
    }
}
